/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MarkExistingCustomerRequest
 */
export interface MarkExistingCustomerRequest {
  /**
   *
   * @type {string}
   * @memberof MarkExistingCustomerRequest
   */
  agreementId: string;
  /**
   *
   * @type {string}
   * @memberof MarkExistingCustomerRequest
   */
  reason: string;
}

/**
 * Check if a given object implements the MarkExistingCustomerRequest interface.
 */
export function instanceOfMarkExistingCustomerRequest(
  value: object,
): value is MarkExistingCustomerRequest {
  if (!("agreementId" in value) || value["agreementId"] === undefined)
    return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  return true;
}

export function MarkExistingCustomerRequestFromJSON(
  json: any,
): MarkExistingCustomerRequest {
  return MarkExistingCustomerRequestFromJSONTyped(json, false);
}

export function MarkExistingCustomerRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarkExistingCustomerRequest {
  if (json == null) {
    return json;
  }
  return {
    agreementId: json["agreementId"],
    reason: json["reason"],
  };
}

export function MarkExistingCustomerRequestToJSON(
  json: any,
): MarkExistingCustomerRequest {
  return MarkExistingCustomerRequestToJSONTyped(json, false);
}

export function MarkExistingCustomerRequestToJSONTyped(
  value?: MarkExistingCustomerRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agreementId: value["agreementId"],
    reason: value["reason"],
  };
}
